import { useEffect, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ObrigadoPage() {
  const navigate = useNavigate();

  useLayoutEffect(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (typeof (window as any).fbq === 'function') {
      (window as any).fbq('track', 'Lead');
    }
  }, []);

  const handleWhatsAppShare = () => {
    const text = encodeURIComponent(
      '🌟 Acabei de me inscrever na Seletiva Four Models!\n\n' +
      '📍 Cidade: Sapezal - MT\n' +
      '📅 Data: 13/03/2026 • Sexta-feira\n' +
      '🕒 Horário: 19h30\n' +
      '🏨 Local: Pelegrini Palace Hotel – Sapezal - MT\n\n' +
      'Inscrição 100% gratuita! Participe você também 👉 https://sapezal.fourmodelsseletivas.com.br'
    );
    window.open(`https://wa.me/?text=${text}`, '_blank');
  };

  const handleBackToSite = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-black flex flex-col">
      {/* Header */}
      <header className="border-b border-yellow-500/20 py-5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex justify-center">
          <img 
            src="https://static.readdy.ai/image/103ec5ada18b00c7d95516c6aa3b7243/3c6853a00769ef0b898cf7c7be2b9fe6.png" 
            alt="Four Models" 
            className="h-10 sm:h-12 object-contain"
          />
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 py-12 sm:py-16 px-4 sm:px-6">
        <div className="max-w-2xl mx-auto">
          {/* Success Icon */}
          <div className="flex justify-center mb-8">
            <div className="relative">
              <div className="absolute inset-0 bg-yellow-500/30 rounded-full animate-ping"></div>
              <div className="absolute inset-0 bg-yellow-500/20 rounded-full animate-pulse"></div>
              <div className="relative w-20 h-20 sm:w-24 sm:h-24 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center shadow-2xl shadow-yellow-500/40">
                <i className="ri-check-line text-black text-4xl sm:text-5xl font-black"></i>
              </div>
            </div>
          </div>

          {/* Title */}
          <div className="w-full text-center mb-4">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-black leading-tight">
              <span className="text-white block">Inscrição</span>
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600 block">
                Confirmada!
              </span>
            </h1>
          </div>

          {/* Subtitle */}
          <p className="text-gray-300 text-base sm:text-lg text-center mb-10 sm:mb-12 max-w-xl mx-auto leading-relaxed">
            Parabéns! Sua vaga está garantida. Entraremos em contato pelo WhatsApp com todos os detalhes.
          </p>

          {/* Event Details Card */}
          <div className="bg-gradient-to-br from-gray-900 to-black border-2 border-yellow-500/30 rounded-2xl p-6 sm:p-8 mb-6">
            <h2 className="text-xl sm:text-2xl font-black text-white mb-6 flex items-center gap-3">
              <div className="w-10 h-10 bg-yellow-500/20 rounded-lg flex items-center justify-center">
                <i className="ri-calendar-event-fill text-yellow-500 text-xl"></i>
              </div>
              Detalhes do Evento
            </h2>

            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-yellow-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-calendar-line text-yellow-500 text-lg"></i>
                </div>
                <div>
                  <p className="text-white font-bold text-base sm:text-lg">13 de Março de 2026</p>
                  <p className="text-gray-400 text-sm">Sexta-Feira</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-yellow-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-yellow-500 text-lg"></i>
                </div>
                <div>
                  <p className="text-white font-bold text-base sm:text-lg">19h30</p>
                  <p className="text-gray-400 text-sm">(não se atrase!)</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-yellow-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-fill text-yellow-500 text-lg"></i>
                </div>
                <div>
                  <p className="text-white font-bold text-base sm:text-lg">Pelegrini Palace Hotel</p>
                  <p className="text-gray-400 text-sm">Sapezal – MT</p>
                </div>
              </div>
            </div>
          </div>

          {/* Next Steps Card */}
          <div className="bg-gradient-to-br from-gray-900 to-black border border-yellow-500/20 rounded-2xl p-6 sm:p-8 mb-6">
            <h2 className="text-xl sm:text-2xl font-black text-white mb-6 flex items-center gap-3">
              <div className="w-10 h-10 bg-yellow-500/20 rounded-lg flex items-center justify-center">
                <i className="ri-list-check text-yellow-500 text-xl"></i>
              </div>
              Próximos Passos
            </h2>

            <div className="space-y-5">
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-black font-black text-sm">1</span>
                </div>
                <p className="text-gray-300 text-sm sm:text-base leading-relaxed pt-1">
                  Aguarde contato pelo WhatsApp com confirmação e orientações
                </p>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-black font-black text-sm">2</span>
                </div>
                <p className="text-gray-300 text-sm sm:text-base leading-relaxed pt-1">
                  Compareça no dia 13/03/2026 às 19h30 no local indicado
                </p>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-black font-black text-sm">3</span>
                </div>
                <p className="text-gray-300 text-sm sm:text-base leading-relaxed pt-1">
                  Menores de 18 anos devem estar acompanhados de um responsável legal
                </p>
              </div>
            </div>
          </div>

          {/* Arrive Early Card */}
          <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-2xl p-6 sm:p-8 mb-6">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-yellow-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-alarm-line text-yellow-500 text-2xl"></i>
              </div>
              <div>
                <h3 className="text-white font-black text-lg sm:text-xl mb-2">Chegue com antecedência!</h3>
                <p className="text-gray-300 text-sm sm:text-base leading-relaxed">
                  Recomendamos chegar 30 minutos antes para credenciamento e palestra introdutória sobre o processo seletivo.
                </p>
              </div>
            </div>
          </div>

          {/* FAQ Card */}
          <div className="bg-gradient-to-br from-gray-900 to-black border border-yellow-500/20 rounded-2xl p-6 sm:p-8 mb-8">
            <h2 className="text-xl sm:text-2xl font-black text-white mb-6 flex items-center gap-3">
              <div className="w-10 h-10 bg-yellow-500/20 rounded-lg flex items-center justify-center">
                <i className="ri-question-answer-fill text-yellow-500 text-xl"></i>
              </div>
              Tudo que você precisa saber
            </h2>

            <div className="space-y-5">
              <div>
                <h3 className="text-white font-bold text-base sm:text-lg mb-2 flex items-center gap-2">
                  <i className="ri-arrow-right-s-fill text-yellow-500"></i>
                  O que é a Seleção de Modelos e Atores?
                </h3>
                <p className="text-gray-400 text-sm sm:text-base leading-relaxed pl-6">
                  É uma avaliação profissional onde especialistas analisam seu potencial para trabalhar em moda, publicidade, TV e redes sociais. Não é necessário ter experiência prévia.
                </p>
              </div>

              <div>
                <h3 className="text-white font-bold text-base sm:text-lg mb-2 flex items-center gap-2">
                  <i className="ri-arrow-right-s-fill text-yellow-500"></i>
                  O que acontece na Seleção?
                </h3>
                <p className="text-gray-400 text-sm sm:text-base leading-relaxed pl-6">
                  Você passará por uma avaliação individual com nossa equipe, que analisará seu perfil, características físicas e potencial artístico. Receberá feedback profissional e orientações sobre próximos passos.
                </p>
              </div>

              <div>
                <h3 className="text-white font-bold text-base sm:text-lg mb-2 flex items-center gap-2">
                  <i className="ri-arrow-right-s-fill text-yellow-500"></i>
                  Como se preparar?
                </h3>
                <p className="text-gray-400 text-sm sm:text-base leading-relaxed pl-6">
                  Vista-se de forma confortável e que valorize seu estilo natural. Evite roupas muito largas ou que escondam seu corpo. Cabelos limpos e bem cuidados. Seja você mesmo!
                </p>
              </div>

              <div>
                <h3 className="text-white font-bold text-base sm:text-lg mb-2 flex items-center gap-2">
                  <i className="ri-arrow-right-s-fill text-yellow-500"></i>
                  Menor de idade precisa ir acompanhado?
                </h3>
                <p className="text-gray-400 text-sm sm:text-base leading-relaxed pl-6">
                  Sim, é obrigatório que menores de 18 anos estejam acompanhados de um responsável legal (pai, mãe ou tutor) durante toda a seleção.
                </p>
              </div>

              <div>
                <h3 className="text-white font-bold text-base sm:text-lg mb-2 flex items-center gap-2">
                  <i className="ri-arrow-right-s-fill text-yellow-500"></i>
                  Como devo ir à Seleção?
                </h3>
                <p className="text-gray-400 text-sm sm:text-base leading-relaxed pl-6 mb-3">
                  Compareça com visual natural e confortável. Traga documento de identidade (RG ou CNH) e, se menor de 18 anos, certidão de nascimento.
                </p>
                <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-4 ml-6">
                  <p className="text-yellow-500 text-sm font-semibold mb-1 flex items-center gap-2">
                    <i className="ri-alert-fill"></i>
                    Atenção:
                  </p>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    Evite maquiagem pesada, acessórios exagerados ou penteados muito elaborados. Queremos conhecer você de forma natural.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="space-y-4">
            <button
              type="button"
              onClick={handleWhatsAppShare}
              className="w-full bg-green-500 hover:bg-green-600 text-white px-6 py-4 rounded-full text-sm sm:text-base font-bold transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-fill text-xl"></i>
              Compartilhar com Amigos no WhatsApp
            </button>

            <button
              type="button"
              onClick={handleBackToSite}
              className="w-full bg-transparent border-2 border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black px-6 py-4 rounded-full text-sm sm:text-base font-bold transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Voltar para o site
            </button>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-yellow-500/20 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <p className="text-gray-600 text-xs sm:text-sm">
            © 2026 Four Models. Todos os direitos reservados.
          </p>
        </div>
      </footer>
    </div>
  );
}